var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 2.25H12.378C14.2402 2.25 15.75 3.75975 15.75 5.622V12.3788C15.75 14.2403 14.2402 15.75 12.378 15.75H5.622C3.75975 15.75 2.25 14.2402 2.25 12.378V5.625C2.25 3.76125 3.76125 2.25 5.625 2.25V2.25Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57012 11.6185L6.96112 9.61304C6.96037 9.61229 5.21662 9.06854 5.21662 9.06854C5.01712 9.00629 5.00737 8.72654 5.20312 8.65154L11.8414 6.09104C12.0866 5.99654 12.3394 6.21179 12.2854 6.46904L11.1701 11.725C11.1049 12.0333 10.7426 12.1705 10.4899 11.983L8.90587 10.813L7.97212 11.722C7.84087 11.848 7.62337 11.7918 7.57012 11.6185V11.6185Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d40dc317c07121fb81ed580dcca7606c.svg";
export { ForwardRef as ReactComponent };